import { render } from "./VUEAppContentGraficiStorici.vue?vue&type=template&id=12394304"
import script from "./VUEAppContentGraficiStorici.vue?vue&type=script&lang=js"
export * from "./VUEAppContentGraficiStorici.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__